import i18n from '@/i18n';
import $api from './request';

const SIZEXT_NAME_MAP = {
  'zh-tw': 'TW',
  zh: 'TW',
  'zh-cn': 'CN',
  cn: 'CN',
  'en-us': 'EN',
  en: 'EN',
  fr: 'FR',
  ja: 'JP',
  de: 'DE',
  es: 'ES',
  ko: 'KR',
  vi: 'VN',
  it: 'IT',
};

const SizeXtName = {
  sizeXtName: null,
  loadSizeXtName() {
    if (this.sizeXtName) return;
    $api.user
      .get('/api/v1/scan_records/size_xt_name')
      .then(({ data }) => {
        this.sizeXtName = data;
      })
      .catch(e => {
        console.log('[ERROR] getSizeXtName:', e.message);
      });
  },
  getName(key, subKey = null) {
    const mtmKey = (subKey ? `_${subKey}__of_` : '') + key.replaceAll(' ', '_');
    if (this.sizeXtName) {
      const mtmName = this.sizeXtName[mtmKey];
      if (mtmName) {
        const name = mtmName[`${SIZEXT_NAME_MAP[i18n.locale]} - Name`] || mtmName['EN - Name'];
        return name.replace(/ *\([^)]*\) */g, '').trim();
      }
    }

    return null;
  },
};

export default SizeXtName;
